<script lang="ts">
import { defineComponent } from 'vue';
import { Banner } from '@components/Banner';
import { HIDE_LOCAL_AUTH_PROVIDER } from '@shell/store/features';

export default defineComponent({
  name: 'AuthProviderWarningBanners',

  components: { Banner },

  data() {
    return { disableLocalAuth: this.$store.getters['features/get'](HIDE_LOCAL_AUTH_PROVIDER) };
  },

  props: {
    tArgs: {
      type:     Object,
      required: true,
      default:  () => { },
    }
  }
});
</script>

<template>
  <div>
    <Banner
      :label="t('authConfig.stateBanner.disabled', tArgs)"
      color="warning"
      data-testid="auth-provider-disabled-warning-banner"
    />
    <Banner
      v-if="disableLocalAuth"
      color="warning"
      data-testid="auth-provider-disable-local-auth-banner"
    >
      <span v-clean-html="t('authConfig.bannerEnableAuthProvider', {}, true)" />
    </Banner>
    <Banner
      color="warning"
      data-testid="auth-provider-admin-permissions-warning-banner"
    >
      <span class="banner-content">
        <span v-clean-html="t('authConfig.associatedWarning', tArgs, true)" />
        <slot name="additional-warning">
          <!--Empty slot content-->
        </slot>
      </span>
    </Banner>
  </div>
</template>

<style lang="scss" scoped>
.banner-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
